const DEFAULT_PLATFORM_URL = 'https://app.formacion.ninja'

/**
 * Public base URL students land on: every link sent to a student points here.
 * It is the gateway they always use, never the new app's own domain
 * (beta.formacion.ninja), which a student should not see.
 */
export function platformUrl(): string {
  return (process.env.NEXT_PUBLIC_PLATFORM_URL?.trim() || DEFAULT_PLATFORM_URL).replace(/\/+$/, '')
}
